<template>
  <portal to="app-portal-dialog">
    <el-dialog
      :visible.sync="isDialogVisible"
      :title="title"
      :show-close="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="dialog-content">
        <span class="newsPendingdialogMessage">{{ $t('News.KeywordWarningMessage') }}</span><br><br><span class="newsPendingdialogMessage__red">{{ $t('News.KeywordWarningMessageRed') }}</span>
      </div>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          type="primary"
          round
          @click="handleConfirm"
        >{{ confirmButtonText }}</el-button>
      </span>
    </el-dialog>
  </portal>
</template>

<script>
export default {
  name: 'NewsMessageDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    confirmButtonText: {
      type: String,
      default: ''
    },
    onConfirm: {
      type: Function,
      default: null
    }
  },

  computed: {
    isDialogVisible: {
      get () {
        return this.visible
      },
      set (val) {
        this.$emit('update:visible', val)
      }
    }
  },
  methods: {
    handleConfirm () {
      if (this.onConfirm) {
        this.onConfirm()
      } else {
        this.$emit('confirm')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-dialog {
  @include basicDialog();
  .el-dialog__header {
    padding: 16px 40px;
  }
  .el-dialog__body {
    overflow-y: unset;
    font-size: map-get($fontSize, 'medium');
    line-height: 1.5;
    padding: 30px 40px 10px 40px;
  }
  .el-dialog__footer {
    border-top: unset;
    text-align: center;
    padding: 20px 0;
  }
}
</style>
